<template>
    <div class="list__item dashboard__item" :class="type">
        <router-link class="dashboard__link" :to="route"></router-link>
        <div class="dashboard__pic"></div>
        <div class="dashboard__content">
            <h4 class="title-h4">
                {{title}}
            </h4>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            route: {
                type: String,
                required: true
            },
            type: {
                type: String,
                required: true
            },
            title: {
                type: String,
                required: true
            }
        }
    }
</script>

<style lang="sass" scoped>
    .dashboard
        &__item
            position: relative
            transition: transform .3s ease, box-shadow .3s ease
            cursor: pointer
            background: transparent
            border-radius: 4px
            &:before
                content: ''
                z-index: 1
                display: block
                position: absolute
                top: 0
                left: 0
                width: 100%
                height: 100%
                border-radius: 4px
                background: linear-gradient(268.61deg, rgba(11, 35, 76, 0.82) 0.72%, rgba(23, 67, 125, 0.78) 99.25%)
            &:hover
                box-shadow: 0px 8px 16px rgba(1, 37, 78, 0.3)
                transform: translateY(-8px)
            &.new-member
                .dashboard__pic
                    background-image: url('~@/assets/images/dashboard/new-member.jpg')
                &:before
                    opacity: 0.85
            &.view-members
                .dashboard__pic
                    background-image: url('~@/assets/images/dashboard/view-members.jpg')
                &:before
                    background: linear-gradient(270.47deg, rgba(198, 84, 30, 0.69) 0.22%, rgba(133, 52, 14, 0.69) 106.12%)
                    opacity: 0.95
            &.statistic-members
                .dashboard__pic
                    background-image: url('~@/assets/images/dashboard/statistic-members.jpg')
                &:before
                    opacity: 0.7
            &.guest-statistics
                .dashboard__pic
                    background-image: url('~@/assets/images/dashboard/guest-statistics.jpg')
                &:before
                    opacity: 0.95
            &.partner-studios
                .dashboard__pic
                    background-image: url('~@/assets/images/dashboard/partner-studios.jpg')
                &:before
                    opacity: 0.8
            &.studio-finder
                .dashboard__pic
                    background-image: url('~@/assets/images/dashboard/studio-finder.jpg')
                &:before
                    opacity: 0.8
            &.view-visits
                .dashboard__pic
                    background-image: url("~@/assets/images/dashboard/view-visits.jpg")
                &:before
                    background: linear-gradient(270.47deg, rgba(198, 84, 30, 0.69) 0.22%, rgba(133, 52, 14, 0.69) 106.12%)
                    opacity: 0.85
            &.question-answer
                .dashboard__pic
                    background-image: url("~@/assets/images/dashboard/question-answer.jpg")
                &:before
                    opacity: 0.95
            &.statistic-members,
            &.guest-statistics,
            &.partner-studios
                .dashboard__content
                    max-width: 254px
                    +xs
                        max-width: 100%
        &__link,
        &__pic
            width: 100%
            height: 100%
        &__link
            position: absolute
            top: 0
            left: 0
            z-index: 2
            display: block
        &__pic
            position: relative
            border-radius: 4px
            overflow: hidden
            +cover
            +r(768)
                background-position: 50% 0%
        &__content
            text-align: center
            position: absolute
            top: 50%
            left: 50%
            transform: translate(-50%, -50%)
            color: $color--white
            z-index: 1
            width: 100%
            text-transform: uppercase
            padding: 0 10px
            .title-h4
                line-height: 32px
</style>